<template>
  <div class="collectCont">
    <!-- 收藏 -->
    <div v-show="collectStep" class="login">
      <div class="login-title">
        <span class="line"></span>
        <span class="line-top-txt">邀您品尝，赶快收藏</span>
        <span class="line"></span>
      </div>
      <div class="userInfo">
        <div class="tel-chunk">
          <span class="icons tel-chunk-icon"></span>
          <input type="tel" class="type-in" v-model="tel" placeholder="请输入您的手机号" maxlength="11"
                 @input="checkNum(tel, 'tel')">
          <div class="verification" @click="count">{{verification}}</div>
        </div>
        <div class="code-chunk">
          <span class="icons code-chunk-icon"></span>
          <input type="text" class="type-in" v-model="pwd" placeholder="请输入验证码" maxlength=6>
        </div>
        <div class="btn" @click="commit">收藏到我的账号</div>
      </div>
    </div>
    <!-- 收藏成功 -->
    <div v-show="!collectStep" class="success">
      <div class="first">
        <ul>
          <li class="bg-faccd0"></li>
          <li class="bg-f27f88"></li>
          <li class="bg-e60012"></li>
        </ul>
        <span class="fs-34-col">收藏成功</span>
        <ul>
          <li class="bg-e60012"></li>
          <li class="bg-f27f88"></li>
          <li class="bg-faccd0"></li>
        </ul>
      </div>
      <p class="mg-b-28">定制口味已存入账号<span class="col-ff6071">{{tel}}</span></p>
      <p>到店就餐时，在iPad上登录该账号，直接下单品尝。</p>
      <p class="fs-20 mg-t-60">私人定制服务仅限“北京世界城店”</p>
    </div>
  </div>
</template>
<script>
  import {Toast} from 'mint-ui';
  import {add, sendMobileCodeByHHT, CheckVerificationCode} from './../config/api.js';
  import ajax from '../../../pub/utils/ajaxUtils.js';

  export default {
    name: "collectCont",
    data() {
      return {
        shopId: '',
        collectStep: true,
        active: false,
        tel: '',
        pwd: '',
        verification: '获取验证码',
        dishListDetailId: '',
        potName: '',
        privateCustomId: '',
      }
    },
    methods: {
      // 只能输入数字
      checkNum(val, attr) {
        const reg = /^\d*$/;
        if (val) {
          if (!new RegExp(reg).test(val)) this[attr] = '';
        }
        else this[attr] = '';
      },
      // 倒计时
      count() {
        const reg = /^[1][3,4,5,7,8][0-9]{9}$/;
        if (!reg.test(this.tel)) {
          Toast({
            message: '请输入正确的手机号',
            position: 'top',
            duration: 2000
          });
          return false;
        }
        if (this.verification === '获取验证码') {
          let params = {
            mobile: this.tel,
          };
          ajax.postJson(sendMobileCodeByHHT, params,
            data => {
              if (data.result === 200)
                Toast({
                  message: '发送成功',
                  position: 'top',
                  duration: 2000
                });
              else
                Toast({
                  message: data.message,
                  position: 'top',
                  duration: 2000
                });
            }
          );
          this.verification = 90;
          let [verificationNum, setTime] = [this.verification - 1];
          if (setTime) clearInterval(setTime);
          setTime = setInterval(() => {
            if (this.verification > 0)
              this.verification = verificationNum--;
            else {
              this.verification = '获取验证码';
              clearInterval(setTime);
            }
          }, 1000)
        }
      },
      // 验证
      verifyFunc() {
        const reg = /^[1][3,4,5,7,8][0-9]{9}$/;
        if (!reg.test(this.tel)) {
          Toast({
            message: '请输入正确的手机号',
            position: 'top',
            duration: 2000
          });
          return false;
        }
        if (!this.pwd) {
          Toast({
            message: '请输入验证码',
            position: 'top',
            duration: 2000
          });
          return false;
        }
        if (this.pwd.length < 6) {
          Toast({
            message: '请输入正确的验证码',
            position: 'top',
            duration: 2000
          });
          return false;
        }
        return true;
      },
      // 提交
      commit() {
        let _c = JSON.parse(sessionStorage.getItem('c'));
        this.dishListDetailId = _c.dishListDetailId;
        this.privateCustomId = _c.privateCustomId;
        this.potName = _c.potName;
        this.shopId = _c.shopId;
        if (this.verifyFunc()) {
          // 验证码校验
          let params = {
            mobileNo: this.tel,
            msgCode: this.pwd,
          };
          ajax.postJson(CheckVerificationCode, params,
            data => {
              if (data.result === 200){
                // 收藏
                let params = {
                  dishListDetailId: this.dishListDetailId,// 菜品明细id
                  potCustomName: this.potName,
                  phone: this.tel,// 手机号
                  parentId: this.privateCustomId,
                  shopId: this.shopId,
                };
                ajax.postJson(add, params,
                  data => {
                    if (data.result === 200) this.collectStep = false;
                    else {
                      Toast({
                        message: data.message,
                        position: 'top',
                        duration: 2000
                      });
                    }
                  }
                )
              }
              else
                Toast({
                  message: data.message,
                  position: 'top',
                  duration: 2000
                });
            }
          );
        }
      }
    }
  }
</script>
<style type="text/stylus" lang="stylus" scoped>
  @import '../../../assets/css/func.styl'
  .collectCont
    box-sizing: border-box
    padding: 0 .42rem .74rem
    background transparent
    input:
    :-webkit-input-placeholder
      color: #8b8b8b
      font-size: .26rem
    input:
    :-moz-placeholder
      color: #8b8b8b
      font-size: .26rem
    input:-moz-placeholder
      color: #8b8b8b
      font-size: .26rem
    input:-ms-input-placeholder
      color: #8b8b8b
      font-size: .26rem
    .login
      font-size: .26rem
      .login-title
        display flex
        align-items center
        justify-content center
        line-height: .66rem
        text-align center
        font-size: .2rem
        color: #8b8b8b
        .line-top-txt
          padding: 0 .08rem
        .line
          width: .44rem
          height: .02rem
          background #aeaeae
      .userInfo
        background: #f1f1f1
        border-radius: .1rem
      .tel-chunk
        display flex
        align-items center
        padding: .26rem 0 .26rem .3rem
        border-radius: .1rem
        border-x(#fff, 0, 2px)
        .tel-chunk-icon
          bg('../images/ico_mobile')
        .verification
          width: 2.06rem
          border-left: .02rem solid #fff
          text-align center
          color: #e60012
      .code-chunk
        display flex
        align-items center
        padding: .26rem 0 .26rem .3rem
        border-radius: .1rem
        .code-chunk-icon
          bg('../images/ico_verification')
      .icons
        width: .4rem
        height: .4rem
        margin-right: .04rem
      .type-in
        flex: 1
        padding-left: .2rem
        background: transparent
        border: none
      .btn
        height: .82rem
        text-align: center
        line-height: .82rem
        color: #fff
        background: #e60012
        border-radius: .1rem
    .success
      display flex
      flex-direction: column
      justify-content: center
      align-items: center
      color: #3f3f3f
      font-size: .28rem
      .first
        display flex
        align-items: center
        justify-content center
        height: 1.5rem
        ul
          display flex
          align-items: center
          justify-content center
        li
          width: .1rem
          height: .3rem
          margin: 0 .05rem
          border-radius: .05rem
          transform: rotate(30deg);
        .bg-faccd0
          background: #faccd0
        .bg-f27f88
          background: #f27f88
        .bg-e60012
          background: #e60012
        .fs-34-col
          font-size: .34rem
          color: #e60012
          padding: 0 .05rem
      .col-ff6071
        color: #ff6071
      .mg-b-28
        margin-bottom: .28rem
      .mg-t-60
        margin-top: .6rem
      .fs-20
        font-size: .2rem
</style>


// WEBPACK FOOTER //
// src/components/share/collect/collectCont.vue